import React from "react";
import { css, AmountInput, DateInput, CustomDropdown, TextInput, StatusBanner, NotesOnlyCard } from "../components/InvestmentForms/SharedComponents";

const TRANSACTION_OPTIONS = [
    { value: "Purchase of Shares",                label: "Purchase of Shares" },
    { value: "Sale of Shares to Third Party",     label: "Sale of Shares to Third Party" },
    { value: "Buyback by Investee from Investor", label: "Buyback by Investee from Investor" },
    { value: "Subscription to Rights Issue",      label: "Subscription to Rights Issue" },
    { value: "Stock Split by Investee",           label: "Stock Split by Investee" },
    { value: "Bonus Issue by Investee",           label: "Bonus Issue by Investee" },
];

export const SubscriptionRightsForm = ({ fd, hc, companyOptions, selectedTransaction, onTransactionChange }) => (
    <div style={{
        border: "1px solid #eaeeed",
        borderRadius: "12px",
        padding: "20px",
        backgroundColor: "#fff",
        marginBottom: "16px"
    }}>
        <div style={{ marginBottom: "20px" }}>
            <CustomDropdown
                label="Nature Of Transaction"
                options={TRANSACTION_OPTIONS}
                placeholder="Select Transaction Type"
                value={selectedTransaction}
                onChange={onTransactionChange}
                fullWidth
            />
        </div>
        <div className={css.formContainer}>
            <DateInput label="Transaction Date" value={fd.transactionDate} onChange={v => hc("transactionDate", v)} />
            <CustomDropdown label="Investor Company" options={companyOptions} placeholder="Select Investor" value={fd.investorCompany} onChange={v => hc("investorCompany", v)} />
            <CustomDropdown label="Investee Company" options={companyOptions} placeholder="Select Investee" value={fd.investeeCompany} onChange={v => hc("investeeCompany", v)} />
            <TextInput label="Rights Ratio" placeholder="Enter ratio" value={fd.rightsRatio} onChange={v => hc("rightsRatio", v)} />
            <TextInput label="Rights Entitlement" placeholder="Enter rights entitlement" value={fd.rightsEntitlement} onChange={v => hc("rightsEntitlement", v)} />
            <TextInput label="Rights Exercised" placeholder="Enter rights exercised" value={fd.rightsExercised} onChange={v => hc("rightsExercised", v)} />
            <TextInput label="Rights Renounced" placeholder="Enter renounced rights" value={fd.rightsRenounced} onChange={v => hc("rightsRenounced", v)} />
            <AmountInput label="Rights Issue Price" value={fd.rightsIssuePrice} onChange={v => hc("rightsIssuePrice", v)} />
            <AmountInput label="Amount Paid" value={fd.amountPaid} onChange={v => hc("amountPaid", v)} />
            <TextInput label="Total Shares Issued In Rights (All Shareholders)" placeholder="Enter No Of Shares" value={fd.totalSharesIssuedInRights} onChange={v => hc("totalSharesIssuedInRights", v)} fullWidth />
        </div>
    </div>
);

const SubscriptionRights = ({ formData, onChange, relationship, onRelChange, companyOptions, consolList, selectedTransaction, onTransactionChange }) => (
    <>
        <SubscriptionRightsForm
            fd={formData}
            hc={onChange}
            companyOptions={companyOptions}
            selectedTransaction={selectedTransaction}
            onTransactionChange={onTransactionChange}
        />
        <StatusBanner relationship={relationship} onRelChange={onRelChange} />
        <NotesOnlyCard formData={formData} onChange={onChange} />
    </>
);

export default SubscriptionRights;